import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { userSchema } from '../user/getUsers';
import { getDataTypeSchema } from '../mw/getDataTypes';
export const getQuestionSchema = baseObjectSchema.extend({
  title: z.string(),
  description: z.string(),
  mwDataTypeId: z.string(),
  mwDataType: getDataTypeSchema,
  image: z.string().optional(),
  sort: z.number(),
  allowNull: z.boolean(),
  isIncludeLastVisitData: z.boolean(),
  qstQuestionnaireId: z.string(),
  createUser: userSchema.optional(),
  updateUser: userSchema.optional(),
  qstQuestionnaire: z
    .object({
      id: z.string(),
      title: z.string().optional(),
      description: z.string().optional(),
      mwQuestionnaireType: z.string().optional(),
      bindingType: z.number().optional(),
    })
    .optional(),
  questionnaireType: z.string().optional(),
  questionnaireName: z.string().optional(),
  halo: z.number().optional(),
  lalo: z.number().optional(),
  qstListId: z.string().optional(),
  qstList: z
    .object({
      id: z.string(),
      multiSelect: z.boolean().optional(),
      qstListRows: z.array(
        z.object({
          id: z.string(),
          description: z.string(),
          qstListId: z.string(),
          sort: z.number(),
        })
      ),
    })
    .optional(),
});

export type GetQuestionResponse = z.infer<typeof getQuestionSchema>;
